import { render, staticRenderFns } from "./SignUp1Form.vue?vue&type=template&id=2189ff89&"
import script from "./SignUp1Form.vue?vue&type=script&lang=js&"
export * from "./SignUp1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports